import { render, staticRenderFns } from "./New_ingredient.vue?vue&type=template&id=723229ed&scoped=true&"
import script from "./New_ingredient.vue?vue&type=script&lang=js&"
export * from "./New_ingredient.vue?vue&type=script&lang=js&"
import style0 from "./New_ingredient.vue?vue&type=style&index=0&id=723229ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723229ed",
  null
  
)

export default component.exports